import isEmpty  from 'lodash/isEmpty';


let compName = 'auth'

const initialState = {
    isAuthenticated: false,
    user: {},
}

export default (state = initialState, action = {}) => {

    switch (action.type) {
        
        case 'SIGNUP':
            return {
                isAuthenticated: !isEmpty(action.user), /* ! flips boolean value */
                user: action.user,
                token: action.token
            }
        case 'INITIATE_LOGIN':
            return {
                loginInProgress: true 
            }
        case 'LOGIN':
            // reconstruct state by assigning state and your object to a new object
            return Object.assign({}, state, {
                isAuthenticated: !isEmpty(action.user), /* ! flips boolean value */
                user: action.user,
                token: action.token
            })
        case 'FINALIZE_LOGIN':
           // reconstruct state by assigning state and your object to a new object.
            return Object.assign({}, state, {
                loginInProgress: false 
            })
        case 'LOGOUT_IN_PROGRESS':
            // reconstruct state by assigning state and your object to a new object.
             return Object.assign({}, state, {
                 logoutInProgress: action.logoutInProgress
             })
        case 'LOGOUT':       /* when user logs out, reset auth status and application status */
            return Object.assign({}, state, {
               isAuthenticated: false,
               user: {},
               items: {},
               token: undefined
            })
        case 'RESET_PASSWORD':       /* when user clicks link on reset password email */
            return {
               isAuthenticated: !isEmpty(action.user),
               user: action.user,
               token: action.token
            }
        case 'CAPTURE_MESSAGE':       /* when user clicks link on reset password email */
            return {
              message: action.message
            }
        case 'AUTH_ERROR':  /* logs auth errors to redux store that renders on login form */
            return Object.assign({}, state, {
               error: action.error
            })
        case 'CLEAR_AUTH_ERROR':  /* reset auth status when unmounting login form, and upon sucessful login */
            return {
               error: ''
            }
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/auth.js